export default __webpack_public_path__ + "static/media/hunt-for-hunter.0b8601ef.jpg";